
/**
 * キャンペンバナーを表すenum
 */
const CampaignBannerType = Object.freeze({
});


export {CampaignBannerType};
